import React, { ReactElement } from "react"
import StyledInput from "./StyledInput"

interface ShipperInputProps {
  value?: string
  onChange: (value: string) => void
  placeholder?: string
  label?: string
  required?: boolean
  width?: string
  height?: string
  disabled?: boolean
}

export default function ShipperInput({
  value = "",
  onChange,
  placeholder = "Nom de l'expéditeur",
  label,
  required = false,
  width,
  height,
  disabled = false,
}: ShipperInputProps): ReactElement {
  return (
    <StyledInput
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      label={label}
      required={required}
      width={width}
      height={height}
      disabled={disabled}
    />
  )
}
